module.exports = __webpack_public_path__ + "img/INTERIOR-ERTIGA-4.741edf52.jpg";